export default __webpack_public_path__ + "static/media/special-offers-banner.49700f91.png";